import { FC } from 'react';
import { Box, Button, Link, Typography } from '@robocorp/components';
import { IconLogoRobocorp } from '@robocorp/icons/logos';
import { ExternalLinks } from '../constants';
import { AvatarIcon } from '~/components/old-ds-components';

// XXX from the content, I'd say that this is not needed anymore

const AccountNotActive: FC = () => (
  <Box display="flex" flexDirection="column" alignItems="center">
    <Box p={32} mt={100} mb={24} maxWidth={480} backgroundColor="grey80" textAlign="center">
      <Box mb={16}>
        <AvatarIcon size="large" placeholder={<IconLogoRobocorp />} />
      </Box>
      <Typography as="h4" mb={8}>
        We&apos;re invite only right now
      </Typography>
      <Typography fontSize="$12">
        But you’re now registered to get a head start when we launch. If you’d like to be a part of
        early access, fill our questionnaire and we’ll add you to the the waiting list.
      </Typography>
      <Box mt={16} mb={16}>
        <Link href={ExternalLinks.EA_QUESTIONNAIRE} target="_blank">
          <Button>Fill early access questionnaire</Button>
        </Link>
      </Box>
      <Typography fontSize="$12">
        or follow{' '}
        <Link href={ExternalLinks.TWITTER} target="_blank">
          @RobocorpInc
        </Link>{' '}
        for updates
      </Typography>
    </Box>
    <Typography fontSize="$12">
      <Link href={ExternalLinks.SUPPORT} color="content.subtle">
        Contact support
      </Link>
    </Typography>
  </Box>
);

export default AccountNotActive;
